// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-accent: #a00a00;
}

body {
  font-size: 14px;
  font-family: Montserrat, Roboto, Helvetica, sans-serif;
}

* {
  box-sizing: border-box;
}

a {
  color: var(--color-accent);
  text-decoration: none;
}

h2 {
  font-size: 20px;
  margin: 0;
}

h3 {
  font-size: 15px;
  margin: 0px 0px 10px;
}

hr {
  border: 0;
  height: 1px;
  width: 100%;
  background: #eee;
  margin: 10px 0;
  flex-shrink: 0;
}

svg path {
  fill: currentColor
}`, "",{"version":3,"sources":["webpack://./src/direflow-components/fvk-qr-code-generator/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;AACF","sourcesContent":[":root {\n  --color-accent: #a00a00;\n}\n\nbody {\n  font-size: 14px;\n  font-family: Montserrat, Roboto, Helvetica, sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  color: var(--color-accent);\n  text-decoration: none;\n}\n\nh2 {\n  font-size: 20px;\n  margin: 0;\n}\n\nh3 {\n  font-size: 15px;\n  margin: 0px 0px 10px;\n}\n\nhr {\n  border: 0;\n  height: 1px;\n  width: 100%;\n  background: #eee;\n  margin: 10px 0;\n  flex-shrink: 0;\n}\n\nsvg path {\n  fill: currentColor\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
